import { BaseModel } from "ReduxStore/index";

export interface OfferIds {
  offerIds: number[];
}

export default class OfferIdsSortedByWeight extends BaseModel<OfferIds> {
  static resource = "OfferIdsSortedByWeight";
}
